import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

import { BaseBtnGroupComponent } from '../base-btn-group';

@Component({
    selector: 'app-optimization-settings-travel-time-distance-btn-group',
    templateUrl: './optimization-settings-travel-time-distance-btn-group.component.html',
    styleUrls: ['./optimization-settings-travel-time-distance-btn-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OptimizationSettingsTravelTimeDistanceBtnGroupComponent),
            multi: true
        }
    ],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptimizationSettingsTravelTimeDistanceBtnGroupComponent extends BaseBtnGroupComponent {
    public readonly options: Array<number> = [0, 50, 100, 200, 300, 500];
}
